import React from "react";
import { Text, View } from "react-native";
import { STYLES } from "../assets/styles";
import CustomIcon from "./CustomIcon";

function Empty({
  text = "No Items",
  iconType = "EvilIcons",
  iconName = "archive",
  style = {},
}) {
  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <CustomIcon
        type={iconType}
        name={iconName}
        style={{
          color: "grey",
          opacity: 0.5,
          fontSize: STYLES.fontSizes.xxlarge * 3,
          marginBottom: 20,
          ...style,
        }}
      />
      <Text style={{ fontWeight: "bold", opacity: 0.5 }}>{text}</Text>
    </View>
  );
}

export default Empty;
